import {texture} from "p3";
import NPC from "./NPC";
import definitions from "../../../definitions";

export default class NPCGnomeBear extends NPC {
    constructor() {
        super(definitions.NPC_ID.GNOME_BEAR);

        this.collisionRadius = 50;
        this.collisionOffsetX = 5;
        this.collisionOffsetY = -18;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("boss_glitzi_bear_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.LARGE, 1, new PIXI.Point(0, 0));
        this.animateIdle(1);
    }
}